import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// TODO: Replace with your project's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDpcWQ32h9iekokm8O7F9JOkSot4pjUC7o",
  authDomain: "brewz101.firebaseapp.com",
  projectId: "brewz101",
  storageBucket: "brewz101.firebasestorage.app", // <-- UPDATE TO THIS!
  messagingSenderId: "813968905569",
  appId: "1:813968905569:web:48c0822889de60fe892120"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };